/* @flow */
import React from 'react';
import { Container } from 'flux/utils';

import SettingsNav from 'settings/components/SettingsNav.jsx';
import CurrentUser from 'auth/CurrentUser';
import FeatureStore from 'stores/FeatureStore';

type State = {
  canGoToTransactionSettings: boolean,
  canOwnGroups: boolean,
  showMessageSettings: boolean,
  showNewAccount: boolean,
};

class SettingsNavContainer extends React.Component {
  state: State;

  static getStores() {
    return [
      CurrentUser,
    ];
  }

  static calculateState() {
    const user = CurrentUser.getUser();
    const canCollectMoney = user.canCollectMoney();
    const canSendMoney = user.canSendMoney();
    const isTeacher = user.isTeacher();
    const canOwnGroups = user.canOwnGroups();
    const showNewAccount = FeatureStore.hasFeature('web.new_account');

    return {
      canGoToTransactionSettings: canCollectMoney || canSendMoney,
      showMessageSettings: isTeacher,
      canOwnGroups,
      showNewAccount,
    };
  }

  render() {
    return (
      <SettingsNav {...this.state} />
    );
  }
}

export default Container.create(SettingsNavContainer);



// WEBPACK FOOTER //
// ./src/settings/containers/SettingsNavContainer.jsx